import { EntityId } from 'entities-next/common'

import { CORPORATE_MANAGER_DETAILS_PATH } from '../../CorporateManager.routes'

export const CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH = `${CORPORATE_MANAGER_DETAILS_PATH}/details`
export function getCorporateDetailsFormDataPath(corporateId: EntityId) {
  return CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH.replace(':corporateId', `${corporateId}`)
}
